export const CONNECTION_QUALITY = Object.freeze({
  excellent: 5,
  good: 3,
  poor: 1,
  unknown: 5,
});
